import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

import ProfileProjects from '../components/profile/ProfileProjects';
import { RESOLVE_LOCAL_USER_STATE } from '../components/auth/AuthActions';
import UserCard from '../components/user/UserCard';
import SweetLoadingSpinner from "../components/eyeCandy/SweetLoadingSpinner.js";
import { FETCH_USER, FETCH_EXTENDED_USER, FETCH_PROJECTS } from '../components/profile/ProfileActions.js';

const tabStyle = (active) => ({
  fontSize: 14, fontWeight: 600, textDecoration: 'none',
  padding: '5px 12px', borderRadius: 6, cursor: 'pointer',
  border: 'none', background: active ? '#59c6c1' : 'transparent',
  color: active ? '#0f172a' : 'var(--muted)',
  transition: 'all 100ms ease',
});

export default function ProfilePage() {
  const { username } = useParams();

  const [auth_user] = useState(RESOLVE_LOCAL_USER_STATE());
  const [profile_user, setProfileUser] = useState('');
  const [profile_extended_user, setProfileExtendedUser] = useState('');
  const [profile_projects, setProfileProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('projects');

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const u = await FETCH_USER(username);
        const [ext, projects] = await Promise.all([
          FETCH_EXTENDED_USER(u.id),
          FETCH_PROJECTS(u.id, true),
        ]);
        if (!cancelled) {
          setProfileUser(u);
          setProfileExtendedUser(ext);
          setProfileProjects(projects);
          setLoading(false);
        }
      } catch (e) {
        console.error('ProfilePage Load Error:', e);
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [username]);

  const auth_user_pk = auth_user?.pk;
  const profile_user_pk = profile_user?.pk;
  const isOwnProfile = !!auth_user_pk && !!profile_user_pk && String(auth_user_pk) === String(profile_user_pk);
  const hasCv = !!(profile_extended_user?.cv);

  return (
    <div className="container" style={{ paddingTop: isOwnProfile ? '20px' : '50px' }}>
      {/* Own-profile banner */}
      {isOwnProfile && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '8px 14px', marginBottom: 20,
          background: 'var(--bg-soft)', border: '1px solid var(--border)',
          borderRadius: 8, fontSize: 13,
        }}>
          <span style={{ color: 'var(--muted)' }}>
            This is your public profile — how others see you.
          </span>
          <a href="/home" style={{ color: '#59c6c1', textDecoration: 'none', fontWeight: 600, fontSize: 13 }}>
            Back to home
          </a>
        </div>
      )}

      <div className="row">
        <div className="col-md-3 col-sm-3 col-xs-12">
          <SweetLoadingSpinner loadingState={loading} />
          <UserCard
            user={profile_user}
            extended_user={profile_extended_user}
            back_home={isOwnProfile}
          />
        </div>

        <div className="col-md-9 col-sm-9">
          {/* Tabs */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
            <button type="button" style={tabStyle(tab === 'projects')} onClick={() => setTab('projects')}>
              Projects
            </button>
            {hasCv && (
              <button type="button" style={tabStyle(tab === 'cv')} onClick={() => setTab('cv')}>
                CV
              </button>
            )}
          </div>
          <hr />

          {tab === 'projects' && (
            <div className="container">
              <SweetLoadingSpinner loadingState={loading} />
              <ProfileProjects projects={profile_projects} />
            </div>
          )}

          {tab === 'cv' && hasCv && (
            <div className="container">
              <div className="custom-body-markdown" style={{ fontSize: 14, lineHeight: 1.7 }}>
                <ReactMarkdown>{profile_extended_user.cv}</ReactMarkdown>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
